export const customers = [
  {
    id: 1,
    name: "Thiel LLC",
    type: "Customer",
    location: "Arvada",
    item: "info",
    contact: "Rayner Lennox",
    accountNumber: "123456",
    email: "test1@me.com",
    phone: "5555555555",
    website: "https://test1.com",
    comments: "Test comments and  note",
  },
  {
    id: 2,
    name: "West and Sons",
    type: "Customer",
    location: "Athens",
    item: "info",
    contact: "-",
    accountNumber: "123456",
    email: "test2@me.com",
    phone: "5555555555",
    website: "https://test2.com",
    comments: "Test 2 comments and  note",
  },
  {
    id: 3,
    name: "Thiel LLC",
    type: "Customer",
    location: "Arvada",
    item: "info",
    contact: "Rayner Lennox",
    accountNumber: "123456",
    email: "test3@me.com",
    phone: "5555555555",
    website: "https://test3.com",
    comments: "Test 3 comments and  note",
  },
  {
    id: 4,
    name: "Thiel LLC",
    type: "Customer",
    location: "Arvada",
    item: "info",
    contact: "Rayner Lennox",
    accountNumber: "123456",
    email: "test4@me.com",
    phone: "5555555555",
    website: "https://test4.com",
    comments: "Test 4 comments and  note",
  },
  {
    id: 5,
    name: "Thiel LLC",
    type: "Customer",
    location: "Arvada",
    item: "info",
    contact: "Rayner Lennox",
    accountNumber: "123456",
    email: "test5@me.com",
    phone: "5555555555",
    website: "https://test5.com",
    comments: "Test 5 comments and  note",
  },
  {
    id: 6,
    name: "Thiel LLC",
    type: "Customer",
    location: "Arvada",
    item: "info",
    contact: "Rayner Lennox",
    accountNumber: "123456",
    email: "test6@me.com",
    phone: "5555555555",
    website: "https://test6.com",
    comments: "Test 6 comments and  note",
  },
  {
    id: 7,
    name: "Thiel LLC",
    type: "Customer",
    location: "Arvada",
    item: "info",
    contact: "Rayner Lennox",
    accountNumber: "123456",
    email: "test7@me.com",
    phone: "5555555555",
    website: "https://test7.com",
    comments: "Test 7 comments and  note",
  },
  {
    id: 8,
    name: "Thiel LLC",
    type: "Customer",
    location: "Arvada",
    item: "info",
    contact: "Rayner Lennox",
    accountNumber: "123456",
    email: "test8@me.com",
    phone: "5555555555",
    website: "https://test8.com",
    comments: "Test 8 comments and  note",
  },
  {
    id: 9,
    name: "Thiel LLC",
    type: "Customer",
    location: "Arvada",
    item: "info",
    contact: "Rayner Lennox",
    accountNumber: "123456",
    email: "test9@me.com",
    phone: "5555555555",
    website: "https://test9.com",
    comments: "Test 9 comments and  note",
  },
  {
    id: 10,
    name: "Thiel LLC",
    type: "Customer",
    location: "Arvada",
    item: "info",
    contact: "Rayner Lennox",
    accountNumber: "123456",
    email: "test10@me.com",
    phone: "5555555555",
    website: "https://test10.com",
    comments: "Test 10 comments and  note",
  },
];

export const customerPlaces = [
  {
    system_id: "392a658e-0299-468a-b9ed-98e221c1a01e",
    parent: null,
    name: "string2",
    address: {
      address_line_1: "string",
      address_line_2: "string",
      city: "string",
      state_or_province: "string",
      country_or_region: "string",
      postal_code: "string",
    },
    contact_name: "string",
    contact_email: "string",
    contact_phone: "string",
    notes: "string",
    child_places: [],
  },
  {
    system_id: "bdeaafbf-e038-403f-93f3-e2ce3b3f7665",
    parent: null,
    name: "string",
    address: {
      address_line_1: "string",
      address_line_2: "string",
      city: "string",
      state_or_province: "string",
      country_or_region: "string",
      postal_code: "string",
    },
    contact_name: "string",
    contact_email: "string",
    contact_phone: "string",
    notes: "string",
    child_places: [
      {
        system_id: "d27e4cc1-8791-4ac6-8bcb-81e9557249f6",
        parent: "bdeaafbf-e038-403f-93f3-e2ce3b3f7665",
        name: "string2Child",
        address: {
          address_line_1: "string",
          address_line_2: "string",
          city: "string",
          state_or_province: "string",
          country_or_region: "string",
          postal_code: "string",
        },
        contact_name: "string",
        contact_email: "string",
        contact_phone: "string",
        notes: "string",
        child_places: [],
      },
    ],
  },
];
